import axios from "axios";
import { loadAuth } from "core/localStorage";
import { clone } from "lodash";
import config from "../envconfig";
import {toast} from "react-toastify";

const AUTH_TOKEN = {
    token: null,
};
export function updateAxios(token) {
    AUTH_TOKEN.token = clone(token);
}

export function getCurrentUserToken() {
    const serializedState = loadAuth();
    return serializedState.id_token;
}
export default function () {
    axios.defaults.baseURL = config.api;
    axios.defaults.withCredentials = true;
    axios.defaults.headers.common["ContentType"] =
        "application/x-www-form-urlencoded; application/json; charset=UTF-8; image/jpeg; image/png; text/plain; application/octet-stream ";
    axios.defaults.headers.common["Accept"] =
        "application/json, application/octet-stream, image/jpeg, image/png, text/plain; application/pdf; ";
    axios.interceptors.request.use(
        (config) => {
            const access_token = AUTH_TOKEN.token;
            if (access_token !== null) {
                config.headers.Authorization = `Bearer ${access_token}`;
            }
            return config;
        },
        (err) => Promise.reject(err)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response) {
                const status = error.response.status;
                if (401 === status && window.location.pathname !== "/login") {
                    window.location.replace("/logout");
                }
                if (403 === status) {
                    toast.error("Insufficient permissions. Please contact support.");
                }
            }
            return Promise.reject(error);
        }
    );

}
const pathUrl = (url, path) => (path ? `/${url}/${path}` : `/${url}`);
export const API_URL = {
    login: (path) => pathUrl("authenticate", path),
    loginSSO: () => axios.defaults.baseURL + config.ssoUrl,
    user: (path) => pathUrl("user", path),
    userAccount: (path) => pathUrl("account", path),
    logoutSSO: () => axios.defaults.baseURL + "/logout",
    advertising: (path) => pathUrl("advertizement", path),
    advertisingAT: () => pathUrl("advertizement-film-release-association-type"),
    advertisingAdvT: () => pathUrl("advertizement-type"),
    advertisingRST: () => pathUrl("review-status-type"),
    attributeType: (path) => pathUrl("attribute-type", path),
    filmCodeT: () => pathUrl("code-type"),
    filmRatingT: () => pathUrl("film-rating-type"),
    filmRelease: (path) => pathUrl("film-release", path),
    filmReleaseAssociationType: (path) => pathUrl("advertizement-film-release-association-type", path),
    companyRelease: (path) => pathUrl("company", path),
    refreshToken: (path) => pathUrl("refresh-token", path),
    review: (path) => pathUrl("review", path),
    report: (path) => pathUrl("report", path),
    tags: (path) => pathUrl("review-tag", path),
    instructionPreset: (path) => pathUrl("instruction-preset", path),
    contact: (path) => pathUrl("contact", path),
    contactRole: (path) => pathUrl("contact-role", path),
    film: (path) => pathUrl("film", path),
    advertizementFilmAssociation: (path) => pathUrl("advertizement-film-association", path),
    apiImport: () => (path) => pathUrl("apiImport", path),
};
export function fakeCall(time) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                data: "payload",
            });
        }, time);
    });
}
export const SELECT_MAX_RESULTS = 50;
